/**
 * The chip row that sits above everything on the phone: Today, then the five
 * categories. Same as Alex's, with Cashflow where 4ocean was.
 */
export default function ChipRow({ categories, current, onChange }) {
  return (
    <div className="chips" role="tablist" aria-label="Categories">
      <button
        type="button"
        role="tab"
        className={'chip' + (current === 'today' ? ' on' : '')}
        aria-selected={current === 'today'}
        onClick={() => onChange('today')}
      >
        Today
      </button>
      {categories.map((c) => (
        <button
          key={c.id}
          type="button"
          role="tab"
          className={'chip' + (current === c.id ? ' on' : '')}
          aria-selected={current === c.id}
          onClick={() => onChange(c.id)}
        >
          <i style={{ background: c.color || 'var(--ink-faint)' }} />
          {c.name}
        </button>
      ))}
    </div>
  )
}
